import React from 'react';
import classNames from 'classnames';
import StylishNewSelect from '../../DesignSystems/New/StylishNewSelect';
import { Controller, useFormContext } from 'react-hook-form';

type FormSelectFieldProps = {
  title: string;
  fieldName: string;
  rules?: { [key: string]: { value: any; message: string } };
  options: { label: string; value: string }[] | undefined;
  placeholder?: string;
  variant?: 'full' | 'half';
  isMulti?: boolean;
  isClearable?: boolean;
  value?: any;
  defaultValue?: any;
  style?: object;
  classes?: string;
  disabled?: boolean;
  onChangeCallback?: (value: string | string[] | undefined) => void;
};

const FormSelectField: React.FC<FormSelectFieldProps> = ({
  title,
  fieldName,
  rules,
  options,
  placeholder,
  variant = 'full',
  isMulti = false,
  isClearable = false,
  value,
  defaultValue,
  style,
  classes,
  disabled = false,
  onChangeCallback,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const required = typeof rules?.required === 'object';

  return (
    <div
      className={classNames('mt-2', {
        'col-6': variant === 'half',
        'col-12': variant === 'full',
      })}
    >
      <label className="form-label">
        {title}
        {required ? (
          <span aria-label="Required field" className="required">
            *
          </span>
        ) : null}
      </label>
      <Controller
        control={control}
        name={fieldName}
        rules={rules}
        render={({ field: { onChange, onBlur, value } }) => (
          <StylishNewSelect
            classes={classes}
            style={style}
            placeholder={placeholder}
            options={options}
            value={options?.filter((option) =>
              isMulti ? value?.includes(option.value) : option.value === value
            )}
            onChange={(selectedOption) => {
              const newValue = isMulti
                ? selectedOption.map((option: any) => option.value)
                : selectedOption?.value || '';
              onChange(newValue);
              onChangeCallback?.(newValue);
            }}
            onBlur={onBlur}
            isMulti={isMulti}
            isClearable={isClearable}
            defaultValue={defaultValue}
            isDisabled={disabled}
          />
        )}
      />
      {errors[fieldName] ? (
        <div className="form-text form-error">
          {errors[fieldName].message as string}
        </div>
      ) : (
        <div className="form-text-none"></div>
      )}
    </div>
  );
};

export default FormSelectField;
